import axios, { AxiosResponse } from "axios";
import { drw_endpoint_url } from "./api";
import { SearchVehicleResponse } from "../screens/AddVehicle/AddVehicleByLicensePlateVin/AddVehicleTypes";
import { SearchVehicleByLicensePlateParams } from "./types";

const searchVehicleByLicensePlateUrl = `/vehicle/licenseplate`;

export const searchVehicleByLicensePlate = async ({
  route,
  plate,
  stateCode,
}: SearchVehicleByLicensePlateParams): Promise<AxiosResponse<SearchVehicleResponse> | void> => {
  return axios.post(`${drw_endpoint_url}/api/${route}${searchVehicleByLicensePlateUrl}`, {
    plate,
    stateCode,
  });
};

export const searchVehicleByVin = async (vin: string, partnerCode: string): Promise<AxiosResponse<SearchVehicleResponse> | void> => {
  return axios.get(`${drw_endpoint_url}/api/omniapi/partner/${partnerCode}/vin/${vin}`);
};
